import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsTransitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_transit"}/>
}
